import { classNames } from '@vedantuadmin/wave-ui';
import React, { FunctionComponent, useEffect, useState } from 'react';
import PoweredByBanner from '../../StudentFlow/PoweredByBanner/PoweredByBanner';
import styles from '../../StudentFlow/EnterCode/EnterCode.module.scss';
import quizEndstyles from '../Arrow/Arrow.module.scss';
import { getAbsImagePath } from '../../../utils/utilFunctions';
import Button from '../../common/Button/Button';

type QuizEndedProps = {
  quizId?: string;
  handleEnterQuiz?: () => void,
};

const QuizEnded: FunctionComponent<QuizEndedProps> = ({ quizId, handleEnterQuiz }) => {
  const [spacedQuizId, setSpacedQuizId] = useState(quizId);
  useEffect(() => {
    let str = '';
    let index = 0;
    while (quizId && index < (quizId?.length || 0)) {
      str += `${quizId.slice(index, index + 3)} `;
      index += 3;
    }
    setSpacedQuizId(str);
  }, []);
  return (
    <div
      className={classNames(
        'enter-code w-1/1 flex-column flex mx-auto h-1/1 bg-orange-0-opac-6 align-items-center',
        'px-16 box-border',
        'overflow-auto',
        styles.EnterCode,
      )}
    >
      <div className="flex-1 flex-center flex-column maxw-350 w-1/1">
        <div className="quiz-brand mb-32">
          <img src={getAbsImagePath('/cdn/images/common/quiz.svg')} width="127" height="53" alt="Quiz" />
        </div>

        <div className="missed-quiz">
          <img src={getAbsImagePath('/cdn/images/common/missedquiz.svg')} width="200" height="180" alt="Missed" />
        </div>

        <div className="quiz-code w-1/1">
          <div className={classNames('mb-16 wt-600 txt-16 txt-center gray-7')}>
            Quiz code
          </div>
          <div className={classNames('wt-400 txt-16 txt-center gray-3')}>
            {spacedQuizId}
          </div>
        </div>
        <div className={classNames('p-16 bg-orange-2', quizEndstyles.arrow)} />
        <div className={classNames('p-16 quiz-end-message w-1/1 round-8 bg-orange-2 z-5 gray-7')}>
          <div className=" wt-600 txt-20 txt-center">
            This Quiz has ended!
          </div>
          <div className=" wt-600 txt-14 txt-center">
            We are sorry, you’re late.
          </div>
        </div>

        <div className="w-1/1 pt-16">
          <Button
            onClick={handleEnterQuiz}
            addClass="w-1/1"
          >
            Enter another quiz
          </Button>
        </div>
      </div>
      <PoweredByBanner wrapperClass="mb-16" />
    </div>
  );
};

export default QuizEnded;
